module.exports = __webpack_public_path__ + "img/prepaid20-pl.365a653e.svg";